export const list = (dispatch, apiClient) => apiClient
  .call({
    endpoint: 'work/list',
  })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'WORK_SET', payload: res.data });
    return res;
  });

export const list2 = (
  dispatch, apiClient, query, skipId,
  actionId, userId, containerId, finish, finishFrom, finishTo) => apiClient
    .call({
      endpoint: 'work/list2',
      data: { query, skipId, actionId, userId, containerId, finish, finishFrom, finishTo }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'WORK_SET', payload: res.data.results });
      return res;
    });

export const active = (dispatch, apiClient) => apiClient
  .call({
    endpoint: 'work/active',
  })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'WORK_SET', payload: res.data });
    return res;
  });

export const available = (dispatch, apiClient) => apiClient
  .call({
    endpoint: 'work/available',
  })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    return res;
  });

export const get = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'work/get', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'WORK_SET', payload: res.data.work });
    dispatch({ type: 'ACTION_SET', payload: res.data.action });
    return res;
  });

export const start = (dispatch, apiClient, actionId, data) => apiClient
  .call({ endpoint: 'work/start', data: { actionId, data } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'WORK_SET', payload: res.data.work });
    dispatch({ type: 'ACTION_SET', payload: res.data.action });
    return res;
  });

export const pause = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'work/pause', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'WORK_SET', payload: res.data });
    return res;
  });

export const resume = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'work/resume', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'WORK_SET', payload: res.data });
    return res;
  });

export const finish = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'work/finish', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'WORK_SET', payload: res.data.work });
    if (res.data.container) { dispatch({ type: 'CONTAINER_SET', payload: res.data.container }); }
    return res;
  });

export const abort = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'work/abort', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'WORK_SET', payload: res.data });
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/work.js